package com.flowyride.core.domain.usecase

import com.flowyride.core.domain.loop.LoopGenerator
import com.flowyride.core.domain.loop.LoopRequest
import com.flowyride.core.domain.model.GeoPoint
import com.flowyride.core.domain.util.suspendRunCatching

/** A generated round trip, ready to be shown like any planned route. */
data class PlannedLoop(
    /** Departure, generated stops, then the departure again. */
    val waypoints: List<GeoPoint>,
    val planned: PlannedRoute,
)

class GenerateLoopUseCase(
    private val generator: LoopGenerator,
    private val computeRoute: ComputeRouteUseCase,
) {
    suspend operator fun invoke(request: LoopRequest): Result<PlannedLoop> = suspendRunCatching {
        val loop = generator.generate(request)
        PlannedLoop(loop.waypoints, computeRoute.analyze(loop.route))
    }
}
